import { twMerge } from 'tailwind-merge';

import { TextFormatType } from '@/components/ui/custom/dataDisplay/Text';
import TextWithTooltip from '@/components/ui/custom/dataDisplay/TextWithTooltip';

export type Props = {
  text?: string;
  className?: string;
  format?: TextFormatType;
};

export default function CoursePathCardTitle(props: Props) {
  const { text = '', className, format = 'poppins-600' } = props;

  return (
    <TextWithTooltip
      text={text}
      as="h2"
      format={format}
      className={twMerge(className, 'text-[1.25rem] truncate w-full')}
    />
  );
}
